import { memo } from "react";

type LastUserMessageProps = {
  text: string;
};

export const LastUserMessage = memo(function LastUserMessage({
  text,
}: LastUserMessageProps) {
  return (
    <div
      className={`nut-w-full nut-mb-4 nut-flex nut-items-start nut-justify-end`}
    >
      <p
        className={`nut-inline-block nut-pt-3 nut-pr-3 nut-pb-3 nut-pl-[23px] nut-bg-[#191919] nut-text-white nut-rounded-tl-[50px] nut-rounded-tr-[20px] nut-rounded-bl-[50px] [@media(max-width:768px)]:nut-text-[13px]`}
      >
        {text}
      </p>
    </div>
  );
});
